import React, { Component } from 'react';
import { Row, Container } from './';
import axios from 'axios';
import HeaderLinks from './header/header-links-v2';
import {
  Logo,
  HomeLink,
  DesktopHeaderLinks,
  HeaderCol,
  LinksCol,
  SearchCol,
  UserCol
} from './header-v2';
import HeaderSearch from './header/header-search-v2';
import HeaderLoggedOut from './header/header-loggedout-v2';
import HeaderLoggedIn from './header/header-loggedin-v2';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

const loginData = {
  logged_in: true,
  google_event_category: 'Header Menu',
  google_event_label: 'Homepage',
  user_role: 'advertiser',
  login_area_web_path: 'https://www.homeimprovementpages.com.au/account/',
  session_id: 'la2t0fotf8kupuq5ngffke36k0',
  hostname: 'fe6.prod.aws.viteknologies.com.au',
  friends_web_path: '/feed',
  username: 'Test User',
  user_id: 17763145,
  user_thumbnail: '17760001_17765000/17763145',
  message_centre_web_path: 'https://www.homeimprovementpages.com.au/message_centre',
  shortlist_web_path: 'https://www.homeimprovementpages.com.au/account/?m=shortlist',
  user_settings_web_path: 'https://www.homeimprovementpages.com.au/account/?m=user&a=settings',
  num_leads: 878,
  number_messages: 3,
  jobs_web_path: '/account/?m=job',
  inspiration_board_web_path: '/user/17763145/inspirationboards',
  email: 'lishengpayment5@mailinator.com',
  phone: '324234234'
};

export class HeaderV2Static extends Component {
  static propTypes = {
    siteSource: PropTypes.string,
    useExampleLoginData: PropTypes.bool,
    isHomepage: PropTypes.bool
  };

  state = {
    loginData: {
      logged_in: false
    }
  };

  async componentDidMount() {
    try {
      let data = {};
      if (this.props.useExampleLoginData === true) {
        //test data for storybook demo
        data = loginData;
        this.setState({
          loginData: data
        });
      } else {
        data = await axios.get('/system/ajax_handlers/user_info.php');
        this.setState({
          loginData: data
        });
      }

      if (typeof window !== 'undefined') {
        // TODO: this should be in redux or something for new header
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          accountId: data.account_id || 0,
          accountType: data.acount_type || 'Unknnown',
          userEmail: data.email || null,
          userID: data.user_id || 0,
          userJobCount: data.job_count || 0,
          userTenure: data.tenure || null,
          userType: data.user_role || 'Anonymous'
        });
      }
    } catch (e) {
      // NOTHINNNGG
    }
  }

  render() {
    const { siteSource, isHomepage } = this.props;
    const { loginData } = this.state;

    if (isHomepage) {
      //no search bar, and get quotes button visible on mobile as well as desktop
      return (
        <Container fluid style={{ background: '#fff' }}>
          <Row flexDirection={'row'} gutter={0}>
            <HeaderCol style={{ flex: 1, alignSelf: 'center' }}>
              <HomeLink
                isHomepage={isHomepage}
                href="/"
                title="Home"
                data-ga-category={GA_CATEGORY}
                data-ga-action={`${GA_CATEGORY} - Clicked Home`}
                data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              >
                <Logo isHomepage={isHomepage} />
              </HomeLink>
              <DesktopHeaderLinks isHomepage>
                <HeaderLinks isHomepage siteSource={siteSource} />
              </DesktopHeaderLinks>
            </HeaderCol>
            <HeaderCol style={{ alignSelf: 'center' }}>
              {loginData.logged_in ? (
                <HeaderLoggedIn
                  {...loginData}
                  loginData={loginData}
                  siteSource={siteSource}
                  isHomepage
                />
              ) : (
                <HeaderLoggedOut loginData={loginData} siteSource={siteSource} isHomepage />
              )}
            </HeaderCol>
          </Row>
        </Container>
      );
    }

    return (
      <Container fluid style={{ background: '#fff' }}>
        <Row flexDirection={'row'} gutter={0}>
          <LinksCol>
            <HomeLink
              isHomepage={isHomepage}
              href="/"
              title="Home"
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Home`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            >
              <Logo isHomepage={isHomepage} />
            </HomeLink>
            <DesktopHeaderLinks>
              <HeaderLinks />
            </DesktopHeaderLinks>
          </LinksCol>

          <SearchCol>
            <HeaderSearch />
          </SearchCol>

          <UserCol>
            {loginData.logged_in ? (
              <HeaderLoggedIn {...loginData} siteSource={siteSource} loginData={loginData} />
            ) : (
              <HeaderLoggedOut siteSource={siteSource} />
            )}
          </UserCol>
        </Row>
      </Container>
    );
  }
}
